module.exports = __webpack_public_path__ + "static/media/icon-character__silvio-berlusconi.b66861f7.svg";